import { format, parse } from 'date-fns';
import * as React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { StorageKeys, getStorageItem } from 'stores/StorageHelper';

const CustomInput = React.forwardRef(({ value, onClick } : any, ref:any) => (
    <button className="relative max-w-sm" onClick={onClick} ref={ref}>
      <div className="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none">
            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
            </svg>
        </div>
        <input value={format(parse(value, "MM/dd/yyyy", new Date()), "dd/MM/yyyy")} readOnly type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date" />
    </button>
));

type DateRangePickerPropTypes = {
  onChange: (startDate: Date, endDate: Date) => void;
  active?: boolean
}

const DateRangePicker: React.FC<DateRangePickerPropTypes> = ({ onChange, active }) => {
    const getStartDate = () : Date => {
      let date: Date;
      const startDate = getStorageItem(StorageKeys.UI_LEDGER_START_DATE);
      if(startDate) date = new Date(startDate);
      else {
        date = new Date();
        date.setMonth(date.getMonth() - 1);
      }
      return date;
    }

    const getEndDate = (): Date => {
      let date:Date;
      const endDate = getStorageItem(StorageKeys.UI_LEDGER_END_DATE) 
      if(endDate) date = new Date(endDate);
      else date = new Date();
      date.setHours(23, 59, 59);
      return date;
    }


    const [startDate, setStartDate] = React.useState(getStartDate());
    const [endDate, setEndDate] =  React.useState(getEndDate());

    const onStartDateChange = (date: Date) => {
      if(date) {
        date.setHours(0,0,0);
        onChange(date, endDate);
        setStartDate(date);
      }
    }

    const onEndDateChange = (date: Date) => {
      if(date) {
        date.setHours(23, 59, 59);
        onChange(startDate, date);
        setEndDate(date);
      }
    }
    
    return (
      <div className={`flex align-center gap-2 ${active ? ' rounded-xl bg-blue-500 p-1 text-sm font-medium text-white transition duration-200 hover:bg-blue-600 active:bg-blue-700 dark:bg-blue-400 dark:text-white dark:hover:bg-blue-300 dark:active:bg-blue-200' : ''}`}  >
        <DatePicker
          selected={startDate}
          onChange={(date) => onStartDateChange(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          customInput={<CustomInput />}
        />
        
        <DatePicker
          selected={endDate}
          onChange={(date) => onEndDateChange(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          customInput={<CustomInput />}
        />
      </div>
    );
  };

export default DateRangePicker;